import { A4uPageRule as IconComponent } from '@adobe/react-spectrum-workflow/dist/PageRule.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function PageRule(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}